import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const URL = import.meta.env.VITE_SUPABASE_URL ?? '';
const ANON = import.meta.env.VITE_SUPABASE_ANON_KEY ?? '';

let cached: SupabaseClient | null = null;

export function getSupabase(): SupabaseClient {
  // E2E escape hatch: tests inject `window.__E2E_SUPABASE__` to skip the real client.
  // No-op in production builds where the property is never set.
  const e2e = (globalThis as { __E2E_SUPABASE__?: SupabaseClient }).__E2E_SUPABASE__;
  if (e2e) return e2e;
  if (cached) return cached;
  cached = createClient(URL, ANON, {
    auth: { persistSession: true, autoRefreshToken: true, storageKey: 'gmma.auth' },
  });
  return cached;
}
